import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const PackageIcon = (props) => (
    <SvgIcon {...props}>
        <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.9091 11.8182H18V1H7.18182V4.09091M11.8182 14.9091H14.9091V4.09091H4.09091V7.18182M1 18H11.8182V7.18182H1V18Z"
                stroke="currentColor"
                stroke-width="1.57765"
            />
        </svg>
    </SvgIcon>
);

export default PackageIcon;
